import React from 'react';

interface TagProps {
  children: React.ReactNode;
  /** Mostra bolinha colorida a esquerda do texto. */
  dot?: boolean;
  /** Tom semantico. `neutral` (default) usa cream + terra. `ok` usa verde suave. */
  tone?: 'neutral' | 'ok';
  className?: string;
}

/**
 * Chip pequeno com bolinha opcional. Usado no header das telas de auth
 * para indicacoes como "v3 · liberada agora" (neutral) ou
 * "30 dias gratis · sem cartao" (ok). So renderiza correto dentro de
 * `<AuthShell>`.
 *
 * Origem: templates/Login com Google/src/brand.jsx <Tag>.
 */
export function Tag({ children, dot, tone = 'neutral', className }: TagProps) {
  const root = ['auth-tag', tone === 'ok' && 'auth-tag--ok', className]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={root}>
      {dot && <span className="auth-tag__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
